<div class="tax-strategy new-input-fields" style="padding: 20px 0">
  <div class="row">
    <div class="medium-2 columns"></div>
    <div class="medium-8 columns" style="margin-bottom: 25px;">
      <div class="create-strategy-sec-bar">
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'info'}" (click)="currentSection = 'info'">
          <div class="sec-name">Template Info</div>
        </div>
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'structure'}" (click)="currentSection = 'structure'">
          <div class="sec-name">Template Structure</div>
        </div>
        <div class="pointer create-strategy-sec" [ngClass]="{'is-active': currentSection == 'review'}" (click)="goToReviewSection()">
          <div class="sec-name">Review</div>
        </div>
      </div>
    </div>
    <div class="medium-2 columns"></div>
  </div>
  <div class="row" style="height: calc(90vh - 23vh);overflow: auto">
    <div class="medium-12 columns" style="margin-top: 20px;" *ngIf="currentSection == 'info'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">{{editMode ? 'Update Template' : 'Create New Template'}}</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Provide Template's Information</label>
          <hr/>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <label>
            Template Name*
            <input type="text" placeholder="Template Name*" [(ngModel)]="template.name">
          </label>
        </div>
        <div class="medium-12 columns">
          <label>
            Notes
            <div style="border:1px solid #cacaca;padding:10px;margin-bottom:20px;" [froalaEditor]="editorOptions" [(froalaModel)]="template.notes"></div>
          </label>
        </div>
      </div>
    </div>
    <div class="medium-12 columns" style="margin-top: 20px;" *ngIf="currentSection == 'structure'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">Template Structure</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Provide Template's Structure</label>
          <hr/>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns margin-top-20" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
            <span class="pointer popup-label" style="color: #1570EF" (click)="appendRate()"><i class="icon ion-ios-plus-outline"></i>Rates</span>
          </div>
          <div class="address-bar row row-margin" *ngIf="template.rates && template.rates.length > 0">
            <div class="small-12 columns">
              <div style="clear: both;" *ngFor="let rate of template.rates;let index = index;">
                <input type="text" class="float-left" style="width: 50%" [(ngModel)]="rate.name" placeholder="Name*"/>
                <input type="text" class="float-left" style="width: 25%;margin-left: 10px;" [(ngModel)]="rate.rate" placeholder="Rate" model-numeral [format]="'0,0'" [locale]="'USD'"/>
                <i class="icon ion-ios-trash float-left" style="margin-left: 10px;" (click)="deleteRate(index)"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns margin-top-20" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
            <span class="pointer popup-label" style="color: #1570EF" (click)="appendFees()"><i class="icon ion-ios-plus-outline"></i>Fees</span>
          </div>
          <div class="address-bar row row-margin" *ngIf="template.fees && template.fees.length > 0">
            <div class="small-12 columns">
              <div style="clear: both;" *ngFor="let fee of template.fees;let index = index;">
                <input type="text" class="float-left" style="width: 50%" [(ngModel)]="fee.description" placeholder="Description*"/>
                <input type="text" class="float-left" style="width: 20%;margin-left: 10px;"[(ngModel)]="fee.amount" placeholder="Amount" model-numeral [locale]="'USD'" [format]="'$0,0.00'"/>
                <span class="float-left" style="width: 20%;margin-left: 10px;">
                  <app-tpiq-select-dropdown [setData]="associatedWithData" (onValueSelect)="setAssociatedWith($event, fee)"
                                         [setDefaultValue]="fee.associatedWith" [setSearchKey]="'name'" [setPlaceHolder]="'Associated With'" [setValueKey]="'id'">
                  </app-tpiq-select-dropdown>
                </span>
                <i class="icon ion-ios-trash float-left" style="margin-left: 10px;" (click)="deleteFees(index)"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns margin-top-20" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
          <div class="address-bar row-margin">
            <span class="pointer popup-label" style="color: #1570EF" (click)="appendStrategy()"><i class="icon ion-ios-plus-outline"></i>Strategies</span>
          </div>
          <div class="address-bar row row-margin" *ngIf="template.strategies && template.strategies.length > 0">
            <div class="small-12 columns">
              <div style="clear: both;" *ngFor="let strategy of template.strategies;let index = index;">
                <span class="float-left" style="width: 30%;">
                  <app-tpiq-select-dropdown [setData]="strategiesList" [includeNone]="false" (onValueSelect)="setStrategy($event, strategy)"
                                         [setDefaultValue]="strategy.strategyId" [setSearchKey]="'name'" [setPlaceHolder]="'Strategy*'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
                </span>
                <input class="float-left" type="text" style="width: 20%;margin-left: 10px;" [(ngModel)]="strategy.amount" placeholder="Amount" model-numeral [locale]="'USD'" [format]="'$0,0.00'"/>
                <span class="float-left" style="width: 25%;margin-left: 10px;">
                  <app-tpiq-select-dropdown [setData]="allAssociatedData[strategy.strategyId] || associatedWithData" (onValueSelect)="setAssociatedWith($event, strategy)"
                                         [setDefaultValue]="strategy.associatedWith" [setSearchKey]="'name'" [setPlaceHolder]="'Associated With'" [setValueKey]="'id'">
                  </app-tpiq-select-dropdown>
                </span>
                <span class="float-left" style="width: 15%;margin-left: 10px;">
                  <input type="checkbox" [(ngModel)]="strategy.recurring" [checked]="strategy.recurring" /> Recurring
                </span>
                <i class="icon ion-ios-trash float-left" style="margin-left: 10px;" (click)="deleteStrategy(index)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medium-12 columns" style="margin-top: 20px; "*ngIf="currentSection == 'review'">
      <div class="row">
        <div class="medium-12 columns">
          <label style="font-weight: 600;color: #333333;">Review</label>
          <label style="font-size: 12px;font-weight: 400;color: #475467;">Check your given information before creating the template</label>
          <hr/>
        </div>
      </div>
      <mat-accordion multi>
        <mat-expansion-panel class="tp-accordion" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Template Information
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row" *ngIf="tempTemplate">
            <div class="medium-12 columns">
              <label class="strategy-view-label">Template Name</label>
            </div>
            <div class="medium-12 columns">
              <div class="strategy-view-content">
                {{tempTemplate.name}}
              </div>
            </div>
            <div class="medium-12 columns">
              <label class="strategy-view-label">Notes</label>
            </div>
            <div class="medium-12 columns update-tax-strategy">
              <div class="strategy-info strategy-view-content" [innerHTML]="tempTemplate.notes"></div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="tp-accordion">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Template Structure
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template [ngIf]="tempTemplate">
            <table style="margin-top: 0 !important;font-size: 15px;color: #333333;">
              <thead>
              <tr>
                <th *ngFor="let column of rateColumns">
                  <span>{{column.title}}</span>
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <ng-template [ngIf]="tempTemplate.rates && tempTemplate.rates.length == 0">
                <tr class="text-center">
                  <td [attr.colspan]="rateColumns.length">
                    <div class="callout text-center">
                      <p>No Results Found.</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template [ngIf]="tempTemplate.rates && tempTemplate.rates.length > 0">
                <tr *ngFor="let row of tempTemplate.rates;let i=index">
                  <td *ngFor="let col of rateColumns;let idx=index">
                    {{row[col.name]}}
                  </td>
                </tr>
              </ng-template>
              </tbody>
            </table>
            <table style="margin-top: 0 !important;font-size: 15px;color: #333333;">
              <thead>
              <tr>
                <th *ngFor="let column of feesColumns">
                  <span>{{column.title}}</span>
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <ng-template [ngIf]="tempTemplate.fees && tempTemplate.fees.length == 0">
                <tr class="text-center">
                  <td [attr.colspan]="feesColumns.length">
                    <div class="callout text-center">
                      <p>No Results Found.</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template [ngIf]="tempTemplate.fees && tempTemplate.fees.length > 0">
                <tr *ngFor="let row of tempTemplate.fees;let i=index">
                  <td *ngFor="let col of feesColumns;let idx=index">
                    <div *ngIf="col.name == 'amount'">
                      {{row[col.name] | formatAmount:'$0,0'}}
                    </div>
                    <div *ngIf="col.name != 'amount'">
                      {{row[col.name]}}
                    </div>
                  </td>
                </tr>
              </ng-template>
              </tbody>
            </table>
            <table style="margin-top: 0 !important;font-size: 15px;color: #333333;">
              <thead>
              <tr>
                <th *ngFor="let column of strategiesColumns">
                  <span>{{column.title}}</span>
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <ng-template [ngIf]="tempTemplate.strategies && tempTemplate.strategies.length == 0">
                <tr class="text-center">
                  <td [attr.colspan]="strategiesColumns.length">
                    <div class="callout text-center">
                      <p>No Results Found.</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template [ngIf]="tempTemplate.strategies && tempTemplate.strategies.length > 0">
                <tr *ngFor="let row of tempTemplate.strategies;let i=index">
                  <td *ngFor="let col of strategiesColumns;let idx=index">
                    <div *ngIf="col.name == 'amount'">
                      {{row[col.name] | formatAmount:'$0,0'}}
                    </div>
                    <div *ngIf="col.name != 'amount'">
                      {{row[col.name]}}
                    </div>
                  </td>
                </tr>
              </ng-template>
              </tbody>
            </table>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="row" style="margin-top: 20px;">
    <div class="medium-12">
      <button class="button small float-right" *ngIf="currentSection == 'review'" (click)="saveTemplate()">{{(editMode) ? 'Update' : 'Create'}}</button>
      <button class="button small float-right" *ngIf="currentSection != 'review'" (click)="goToNextSection()">Next</button>
      <button class="button small float-right" *ngIf="currentSection != 'overview'" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="goToPreviousSection()">Previous</button>
      <button class="button small float-right cancel-button" (click)="closeCreateOrUpdatePopup()">Cancel</button>
    </div>
  </div>
</div>
